module.exports = __webpack_public_path__ + "static/media/xls.7fd07375.svg";